<template>
  <div class="box">
    <div id="startup">
      Startup
    </div>
  </div>
</template>

<script>
export default {
  name: 'Startup',
  computed: {
    viewerName () {
      return this.$route.params.viewerName
    },
    type () {
      return this.$route.params.type
    },
  },
  async created () {
    const vm = this
    setTimeout(async function () {
      console.log('kreiran')
      if (vm.$store.getters.getConfigJson) {
        if (vm.$store.getters.getConfigJson.appConfig) {
          if (vm.$store.getters.getConfigJson.appConfig.startUpFunction) {
          /* eslint-disable */  
          const promise = new Promise((resolve, reject) => {
            resolve(startUp());
          });
          promise.then((value) => {
            console.log(value);
            vm.$router.push('/' + vm.viewerName + '/' + vm.type)
          });
          /* eslint-enable */
          }
        }
      }
    }, 1000)
  },
}
</script>
<style scoped>
.box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.box div {
  width: 100px;
  height: 100px;
}

</style>
